import Vue from 'vue'
import VueRouter from 'vue-router'
import login from '@/views/LoginView.vue'
// import attendance from '@/views/Attendance'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/login' },
  { path: '/login', component: login },
  // 自助注册 / 忘记密码（免登录页面）
  // 注册已关闭（2026-10-22）：权限体系没做完，注册进来的人能看全部数据 → 数据泄露。
  // 直接输 /register 也跳回登录页，别让页面留在那儿误导人；账号一律由管理员开通。
  { path: '/register', redirect: '/login' },
  { path: '/forgot', component: () => import('@/views/ForgotPassword.vue') },
  { path: '/sign/:token', component: () => import('@/views/SignPage.vue') },
  {
    // path: '/',
    // name: 'home',
    // component: HomeView
    path: '/home',
    component: () => import('@/views/HomeView.vue'),
    // redirect: '/customerList',
    children: [
      {
        // 员工入职管理
        path: '/EmployeeOnboardingManagement',
        component: () => import('@/views/EmployeeOnboardingManagement.vue')
      },
      {
        // 员工入职管理
        path: '/BD',
        component: () => import('@/views/BD.vue')
      },
      {
        // 员工入职管理
        path: '/Company',
        component: () => import('@/views/Company.vue')
      },
      {
        // 员工入职管理
        path: '/test',
        component: () => import('@/views/TestA.vue')
      },
      {
        path: '/attendance',
        component: () => import('@/views/Attendance.vue')
      },
      {
        path: '/import',
        component: () => import('@/views/import')
      },
      {
        path: '/candidate',
        component: () => import('@/views/Candidate')
      },
      {
        path: '/position',
        component: () => import('@/views/position')
      },
      {
        path: '/shorttermprojects',
        component: () => import('@/views/shorttermprojects')
      },
      {
        path: '/ContractManage',
        component: () => import('@/views/ContractManage')
      },
      {
        path: '/ContractTemplate',
        component: () => import('@/views/ContractTemplate')
      },
      {
        path: '/NetworkProtection',
        component: () => import('@/views/NetworkProtection')
      },
      {
        path: '/maimai',
        component: () => import('@/views/MaiMai')
      },
      {
        // 企查查公司画像（tb_company_qcc）
        path: '/company_qcc',
        component: () => import('@/views/CompanyQcc')
      },
      {
        path: '/CalculateProfit',
        component: () => import('@/views/CalculateProfit')
      },
      {
        path: '/RecommendSearch',
        component: () => import('@/views/RecommendSearch')
      },
      {
        path: '/SurnameManage',
        component: () => import('@/views/SurnameManage')
      },
      {
        path: '/WebSiteManagement',
        component: () => import('@/views/WebSiteManagement')
      },
      {
        path: '/Promotion',
        component: () => import('@/views/Promotion')
      }
    ]
  }
]

// path: '/import',
//     component: Layout,
//     hidden: true, // 不显示在左侧菜单中
//     children: [{
//       path: '', // 什么都不写表示默认的二级路由
//       component: () => import('@/views/import')
//     }]

const router = new VueRouter({
  routes
})
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title === undefined ? 'HROCloud人力资源管理系统' : to.meta.title
  // 公开页面：登录页、注册、忘记密码、首页、员工签署页（免登录）
  if (to.path === '/' || to.path === '/login' || to.path === '/register' ||
      to.path === '/forgot' || to.path.indexOf('/sign/') === 0) {
    next()
    return
  }
  // 获取token值
  const tokenStr = window.sessionStorage.getItem('token')
  if (!tokenStr) return next('/login')
  next()
})
export default router
